import { getContext, setContext } from 'svelte';

import type { InstitutionType } from '@do/models';

const institutionContextKey = Symbol();

export function setInstitutionTypeContext(type: InstitutionType) {
  return setContext<InstitutionType>(institutionContextKey, type);
}

export function getInstitutionTypeContext() {
  return getContext<InstitutionType>(institutionContextKey);
}
